import type { PlanManagementResponse } from '@/api/gen/_model/planManagementResponse';

export const resolvePurchaseCheckoutPolicy = ({
  entry,
  management,
}: {
  entry: { startDate?: string; school?: boolean; userCount?: number };
  management: PlanManagementResponse;
}):
  | { allowed: true }
  | {
      allowed: false;
      reason:
        | 'school_group_unavailable'
        | 'organization_workspace'
        | 'future_purchase_unavailable';
    } => {
  if (
    (entry.school || (entry.userCount ?? 1) > 1) &&
    (management.workspaceScope === 'PERSONAL' ||
      management.currentPlan ||
      management.futurePurchasedPlans.length > 0)
  ) {
    return { allowed: false, reason: 'school_group_unavailable' };
  }
  if (management.workspaceScope === 'ORGANIZATION') {
    return { allowed: false, reason: 'organization_workspace' };
  }

  const isFuturePurchase =
    entry.startDate !== undefined || management.workspaceScope === 'PERSONAL';
  if (isFuturePurchase && management.actions.canPurchaseFuture === false) {
    return { allowed: false, reason: 'future_purchase_unavailable' };
  }

  return { allowed: true };
};
